import { Commit, StoreOptions } from 'vuex';
import pkg from 'package.json';
import { compareVersion } from '@/renderer/scripts/utils/tools/index';
import storage from '@/renderer/scripts/utils/storage';
import { httpUrl } from '@/renderer/scripts/http';
import smh from '@/renderer/scripts/smh';
import { IS_DEV, IS_TEST, IS_PRE, platform } from '@/common/constant/platform';
export interface UpdateState {
  currVersion: string;
  latestVersion: string;
  hasNewVersion: boolean;
  updateLevel: number;
  loading: boolean;
  forceUpdate: {
    versions: string[];
    needToUpdate: string;
  };
}
interface ActionParam {
  commit: Commit;
  state: UpdateState;
}
const update: StoreOptions<UpdateState> = {
  state: {
    // 版本更新
    currVersion: pkg.version,
    latestVersion: pkg.version,
    hasNewVersion: false,
    // 正在拉取远端版本
    loading: false,
    // 更新级别 0: 无更新 1 大版本迭代 2 小版本迭代
    updateLevel: 0,
    forceUpdate: {
      // 有问题的版本号
      versions: [],
      // 需要升级的最小版本
      needToUpdate: '0.0.0',
    },
  },
  mutations: {
    SET_LATEST_VERSION(state: UpdateState, version: string): void {
      state.latestVersion = version;
      const updateLevel = compareVersion(state.currVersion, version);
      state.updateLevel = updateLevel;
      if (updateLevel <= 0) {
        storage.set(storage.StoreKey.MAJOR_VERSION, '0');
        return;
      }
      state.hasNewVersion = true;
    },
    SET_FORCE_UPDATE(state: UpdateState, forceUpdate: UpdateState['forceUpdate']): void {
      state.forceUpdate = forceUpdate;
    },
    SET_UPDATE_LOADING(state: UpdateState, loading: boolean): void {
      state.loading = loading;
    },
  },
  getters: {
    updateLevel: (state: UpdateState): number => state.updateLevel,
    currVersion: (state: UpdateState): string => state.currVersion,
    latestVersion: (state: UpdateState): string => state.latestVersion,
    hasNewVersion: (state: UpdateState): boolean => state.hasNewVersion,
    forceUpdate: (state: UpdateState): UpdateState['forceUpdate'] => state.forceUpdate,
    updateLoading: (state: UpdateState): boolean => state.loading,
  },
  actions: {
    async GetForceUpdateSettings({ commit }: ActionParam): Promise<UpdateState['forceUpdate']> {
      const domain = httpUrl.webUrl;
      const filePath = '/api/upgrade/force-upgrade';
      const updatePath =
        window.location.search.includes('beta') || IS_DEV || IS_TEST || IS_PRE ? `${filePath}?beta=1` : filePath;
      const url = domain + updatePath;
      return smh
        .request({
          baseURL: domain,
          url,
          params: {
            pcVersion: pkg.version,
            systemVersion: process.getSystemVersion(),
            platform,
          },
        })
        .then(res => {
          const { data } = res;
          const obj = {
            versions: data.versions || [],
            needToUpdate: data.needToUpdate || '0.0.0',
          };
          commit('SET_FORCE_UPDATE', obj);
          return obj;
        });
    },
  },
};
export default update;
